import {
  CommissionEndpoints,
  IGetCategoryCommissionHistoryDTO,
  IGetCategoryCommissionHistoryResponse,
  IGetCategoryCommissionsResponse,
  IGetCommissionHistoryFiltersResponse,
  IGetCommissionHistoryListDTO,
  IGetCommissionHistoryListResponse,
  IUpdateCategoryCommissionsDTO,
} from '@/models/commission.model';
import { ApiResponse, httpClient } from '@/utils';

class CommissionAPI {
  static getCategoryCommissions(): ApiResponse<IGetCategoryCommissionsResponse> {
    return httpClient.get<IGetCategoryCommissionsResponse>(CommissionEndpoints.CATEGORY_COMMISSIONS);
  }

  static updateCategoryCommissions(data: IUpdateCategoryCommissionsDTO): ApiResponse<{ data: boolean }> {
    return httpClient.put<{ data: boolean }>(CommissionEndpoints.CATEGORY_COMMISSIONS, data);
  }

  static getCategoryCommissionHistory({
    categoryId,
  }: IGetCategoryCommissionHistoryDTO): ApiResponse<IGetCategoryCommissionHistoryResponse> {
    return httpClient.get<IGetCategoryCommissionHistoryResponse>(
      `${CommissionEndpoints.CATEGORY_COMMISSIONS}/${categoryId}/history`,
    );
  }

  static getCommissionHistoryList(data: IGetCommissionHistoryListDTO): ApiResponse<IGetCommissionHistoryListResponse> {
    return httpClient.get<IGetCommissionHistoryListResponse>(CommissionEndpoints.CATEGORY_COMMISSIONS_HISTORY, {
      params: data,
    });
  }

  static getCommissionHistoryFilters(): ApiResponse<IGetCommissionHistoryFiltersResponse> {
    return httpClient.get<IGetCommissionHistoryFiltersResponse>(
      CommissionEndpoints.CATEGORY_COMMISSIONS_HISTORY_FILTERS,
    );
  }
}

export default CommissionAPI;
